/**
 * Scraper module (v1.9) — research agents combining an LLM with Tavily web
 * search. Five-step pipeline: clarify → plan → search → synthesize → persist.
 *
 * Mirrors the AI-agent grant pattern (per-agent grants) and the
 * Content-Calendar share pattern (PDF + recipient list).
 */
// ----------------------------------------------------------------------------
// Enumerations
// ----------------------------------------------------------------------------
export const SCRAPER_TEMPLATES = [
    'google_maps',
    'linkedin',
    'ecommerce',
    'news',
    'jobs',
    'generic',
    'custom',
];
export const SCRAPER_PROVIDERS = [
    'openai',
    'anthropic',
    'deepseek',
    'gemini',
];
export const SCRAPER_OUTPUT_FORMATS = ['auto', 'text', 'table'];
export const SCRAPER_SEARCH_DEPTHS = ['basic', 'advanced'];
/**
 * Which API step 3 fans out against.
 *
 *  - `tavily`          — prose web search; results need LLM synthesis to
 *                        become structured. The default for every template.
 *  - `gmaps_extractor` — G Maps Extractor /v2/search; returns structured
 *                        business rows that map straight to table columns,
 *                        so the synthesis step is skipped entirely.
 */
export const SCRAPER_SEARCH_BACKENDS = ['tavily', 'gmaps_extractor'];
/** The API caps `page` at 10 and returns at most 20 rows per page. */
export const GMAPS_MAX_PAGES_LIMIT = 10;
export const GMAPS_ROWS_PER_PAGE = 20;
export const SCRAPER_AGENT_STATUSES = ['active', 'archived'];
export const SCRAPER_SESSION_STATUSES = [
    'active',
    'running',
    'completed',
    'failed',
    'cancelled',
];
export const SCRAPER_MESSAGE_ROLES = [
    'user',
    'agent',
    'tool',
    'result',
    'system',
];
export const SCRAPER_SHARE_STATUSES = [
    'pending',
    'generating',
    'delivered',
    'failed',
];
//# sourceMappingURL=scraper.js.map